import type { TheoryBlock } from '../../types/course';
import { Figure } from './CoursePictures';
import styles from './Course.module.css';
import { InlineText } from './InlineText';

type TextBlock = Exclude<TheoryBlock, { kind: 'figure' }>;
interface Group { texts: TextBlock[]; figure: { image: string; caption: string } | null }

/** A figure attaches to the text group right before it; on wide screens they sit side by side. */
export function groupBlocks(blocks: TheoryBlock[]): Group[] {
  const groups: Group[] = [];
  let cur: Group = { texts: [], figure: null };
  for (const b of blocks) {
    if (b.kind === 'figure') {
      if (cur.figure) { groups.push(cur); cur = { texts: [], figure: null }; }
      cur.figure = { image: b.image, caption: b.caption };
    } else {
      if (cur.figure) { groups.push(cur); cur = { texts: [], figure: null }; }
      cur.texts.push(b);
    }
  }
  if (cur.texts.length > 0 || cur.figure) groups.push(cur);
  return groups;
}

export function Theory({ pages }: { pages: TheoryBlock[][] }): JSX.Element {
  return (
    <div data-testid="lesson-theory">
      {pages.map((page, pi) => (
        <section key={pi} className={styles.page}>
          {pi > 0 && <hr className={styles.divider} />}
          {groupBlocks(page).map((g, gi) => (
            <div key={gi} className={g.figure && g.texts.length > 0 ? styles.groupWide : styles.group}>
              {g.texts.length > 0 && (
                <div className={styles.texts}>
                  {g.texts.map((b, bi) =>
                    b.kind === 'heading' ? (
                      <h3 key={bi} className={styles.h3}><InlineText text={b.text} /></h3>
                    ) : (
                      <p key={bi} className={styles.text}><InlineText text={b.text} /></p>
                    ),
                  )}
                </div>
              )}
              {g.figure && <Figure image={g.figure.image} caption={g.figure.caption} />}
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
